<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link
        to="/admin-dashboard"
        class="d-flex align-center text-decoration-none"
        aria-label="Home"
      >
        <brand-logo :variant="$vuetify.theme.dark ? 'on-dark' : 'on-light'" size="md" />
      </router-link>
    </div>
    <div class="px-6 pb-2 caption text--secondary">
      {{ $t('staff_console') }}
    </div>

    <!-- Navigation Items -->
    <v-list
      expand
      shaped
      class="vertical-nav-menu-items pr-5"
    >
      <nav-menu-link
        :title="$t('dashboard')"
        :to="{ name: 'admin-dashboard' }"
        :icon="icons.mdiHomeOutline"
      ></nav-menu-link>
      <nav-menu-section-title :title="$t('schools')"></nav-menu-section-title>
      <nav-menu-link
        :title="$t('schools')"
        :to="{ name: 'schools' }"
        icon="mdi-school"
      ></nav-menu-link>
      <nav-menu-section-title :title="$t('PLANS')"></nav-menu-section-title>
      <nav-menu-link
        :title="$t('school_plans')"
        :to="{ name: 'school-plans' }"
        icon="mdi-alpha-s-box-outline"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('parent_plans')"
        :to="{ name: 'parent-plans' }"
        icon="mdi-alpha-p-box-outline"
      ></nav-menu-link>
      <nav-menu-section-title :title="$t('PAYMENTS')"></nav-menu-section-title>
        <nav-menu-link
            :title="$t('payments')"
            :to="{ name: 'payments' }"
            icon="mdi-credit-card-outline"
        ></nav-menu-link>
      <nav-menu-section-title :title="$t('SETTINGS')"></nav-menu-section-title>
      <nav-menu-link
        :title="$t('change_password')"
        :to="{ name: 'change-password' }"
        icon="mdi-lock-reset"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('settings')"
        :to="{ name: 'settings' }"
        icon="mdi-cog"
      ></nav-menu-link>
      <nav-menu-link
        title="Regions and cities"
        :to="{ name: 'places' }"
        icon="mdi-map-marker-radius"
      ></nav-menu-link>
      <!-- Privacy policy -->
      <nav-menu-link
        :title="$t('Privacy Policy')"
        :to="{ name: 'privacy-policy' }"
        icon="mdi-shield-account"
      ></nav-menu-link>
      <!-- Terms and Conditions -->
      <nav-menu-link
        :title="$t('Terms & Conditions')"
        :to="{ name: 'terms-and-conditions' }"
        icon="mdi-file-document-outline"
      ></nav-menu-link>
      <br/>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiMapMarkerPath,
  mdiCrosshairsGps
} from '@mdi/js'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'
import BrandLogo from '@/components/BrandLogo.vue'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
    BrandLogo,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiMapMarkerPath,
        mdiCrosshairsGps
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
